/* eslint-disable no-shadow */
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import EditOfficialPopup from './EditOfficialPopup';
import InfoButton from '../../../components/InfoButton';
import BackgroundImage from '../../../components/BackgroundImage';
import { ConfirmActionPopup } from '../../../components/PopUps';

import { PopUpTypes, sortEventOfficialsByRoleThenAlphabetically } from '../../../utils/events';
import * as drawEditActions from '../../../actions/draw-edit-actions';

const OfficialsListV2 = () => {
    const { officials, event, clubOfficialMembers } = useSelector(({ drawEdit }) => {
        const { officials, event, clubOfficialMembers } = drawEdit;
        return { officials, event, clubOfficialMembers };
    });
    const dispatch = useDispatch();

    const filteredClubOfficialMembers = clubOfficialMembers ? clubOfficialMembers.data.filter(clubMember => !officials?.data.some(official => official.memberId === clubMember.memberId)) : [];
    const [showEditOfficialPopUp, setShowEditOfficialPopUp] = useState();
    const [showRemovingOfficialPopup, setShowRemovingOfficialPopup] = useState();
    const [officialToEdit, setOfficialToEdit] = useState(null);

    function editOfficial(officialId) {
        if (officialId) {
            const official = officials.data.find(off => off.id === officialId);
            if (official) {
                setOfficialToEdit(official);
            }
        } else {
            setOfficialToEdit(null);
        }
        setShowEditOfficialPopUp(true);
    }

    function removeOfficial(e, idx) {
        const sortedOfficials = sortEventOfficialsByRoleThenAlphabetically(officials.data);
        e.stopPropagation();
        setOfficialToEdit(sortedOfficials[idx]);
        setShowRemovingOfficialPopup(true);
    }

    async function handleRemoveConfirm() {
        await dispatch(drawEditActions.inactivateEventOfficial(event.data.id, officialToEdit.id));
        setShowRemovingOfficialPopup(false);
    }

    return (
        <div className={``}>
            <div className="title mb16">
                <h4 data-testid="officials.title">Manage Event Officials</h4>
                <small style={{ textTransform: 'unset' }} data-testid="officials.subtitle">Add/remove event officials and edit their details</small>
            </div>
            <div className={`row`}>
                <div className="col-12">
                    <div className="form-group form-group-xl">
                        <label>
                            Event Officials
                            <InfoButton hoverText={`Event Officials can be added to matches they are officiating`} />
                        </label>
                        {sortEventOfficialsByRoleThenAlphabetically(officials.data || []).map((official, idx) => {
                            return (
                                <div className="event-admin-card d-flex clickable" key={idx} onClick={() => editOfficial(official.id)} data-testid={`officials.item-${official.id}`}>
                                    <BackgroundImage
                                        baseUrl={'/v1/player/'}
                                        defaultImage={'/img/v2/icons/icon-avatar-player.svg'}
                                        images={official.playerProfileImages}
                                        imageType={'icon'}
                                        parentStylesClass={'avatar'}
                                    />
                                    <div className="person-details">
                                        <div className="person-title text-small text-medium" data-testid={`officials.item-${official.id}.role`}>
                                            {official.role}
                                        </div>
                                        <div className="person-name text-dark">
                                            <span data-testid={`officials.item-${official.id}.name`}>{official.firstName} {official.lastName}</span>
                                            <small
                                                className="cursor-pointer text-teal ml8 d-inline-block"
                                                onClick={(ev) => {
                                                    removeOfficial(ev, idx);
                                                }}
                                                data-testid={`officials.item-${official.id}.remove-btn`}
                                            >
                                                Remove
                                            </small>
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                        <small
                            className={`cursor-pointer ${clubOfficialMembers.error ? 'text-error' : 'text-teal'}`}
                            onClick={!clubOfficialMembers.error ? editOfficial : undefined}
                            data-testid="officials.add-btn"
                        >
                            {clubOfficialMembers.error || 'Add Official'}
                        </small>
                    </div>
                </div>
            </div>
            {showEditOfficialPopUp && (
                <EditOfficialPopup
                    officialToEdit={officialToEdit}
                    clubOfficialMembers={filteredClubOfficialMembers}
                    closePopup={() => {
                        setShowEditOfficialPopUp(false);
                        setOfficialToEdit(null);
                    }}
                    data-testid="modal.draw-edit.edit-official"
                />
            )}
            {showRemovingOfficialPopup && (
                <ConfirmActionPopup
                    onCloseClick={() => {
                        setShowRemovingOfficialPopup(false);
                    }}
                    onCtaClick={handleRemoveConfirm}
                    confirmationTitle="Remove Official"
                    confirmationMessage={PopUpTypes.REMOVE_EVENT_OFFICIAL.message}
                    data-testid="modal.draw-edit.remove-official"
                />
            )}
        </div>
    );
};

export default OfficialsListV2;
